export const namespaced = true;

export const state = {
    airCabins: [],
    carSizes: [],
    cities: [],
    countries: [],
    hotelGuaranteeTypes: [],
    disallowedEmailDomains: [],
}

export const mutations = {
    ADD_AIR_CABINS(state, payload){
        // Save as an object - {a: 'A'}
        state.airCabins = payload;
        // Save as an array with key/value pairs - [{key: 'a", value: 'A'}]
        //state.airCabins = Object.entries(payload).map(([key, value]) => ({ key, value }));
    },
    ADD_CAR_SIZES(state, payload) {
        state.carSizes = payload;
    },
    ADD_CITIES(state, payload) {
        state.cities = payload;
    },
    ADD_COUNTRIES(state, payload) {
        state.countries = payload;
    },
    ADD_HOTEL_GUARANTEE_TYPES(state, payload) {
        state.hotelGuaranteeTypes = payload;
    },
    ADD_DISALLOWED_EMAIL_DOMAINS(state, payload) {
        state.disallowedEmailDomains = payload;
    }
}

export const actions = {
    setOptions(context, payload) {
        console.log(payload);
        context.commit('ADD_AIR_CABINS', payload.airCabins);
        context.commit('ADD_CAR_SIZES', payload.carSizes);
        context.commit('ADD_CITIES', payload.cities);
        context.commit('ADD_COUNTRIES', payload.countries);
        context.commit('ADD_HOTEL_GUARANTEE_TYPES', payload.hotelGuaranteeTypes);
        context.commit('ADD_DISALLOWED_EMAIL_DOMAINS', payload.disallowedEmailDomains);
    },
}

export const getters = {}